import { configureStore } from '@reduxjs/toolkit'
import authReducer          from './slices/authSlice'
import auditReducer         from './slices/auditSlice'
import dashboardReducer     from './slices/dashboardSlice'
import transactionReducer   from './slices/transactionSlice'
import rulesReducer         from './slices/rulesSlice'
import alertsReducer        from './slices/alertsSlice'
import adminReducer         from './slices/adminSlice'
import orchestrationReducer from './slices/orchestrationSlice'
import merchantsReducer     from './slices/merchantsSlice'
import reportsReducer       from './slices/reportsSlice'
import settingsReducer      from './slices/settingsSlice'
import entityListReducer   from './slices/entityListSlice'

const store = configureStore({
  reducer: {
    auth:          authReducer,
    audit:         auditReducer,
    dashboard:     dashboardReducer,
    transactions:  transactionReducer,
    rules:         rulesReducer,
    alerts:        alertsReducer,
    admin:         adminReducer,
    orchestration: orchestrationReducer,
    merchants:     merchantsReducer,
    reports:       reportsReducer,
    settings:      settingsReducer,
    entityList:    entityListReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: { ignoredPaths: ['auth.ability'] },
    }),
})

export default store